import axiosInstance from "../services/config/axiosinstance";
import { urlBaseVibra } from "./config/index";

export async function deleteAttendeeByEmail(eventId, email, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/resellers/emails/${email}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function deleteAttendeeByDocument(eventId, document, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/resellers/documents/${document}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function deleteEmployeeByEmail(eventId, email, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/employees/emails/${email}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function deleteEmployeeByDocument(eventId, document, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/employees/documents/${document}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function deleteGuestByEmail(eventId, email, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/guests/emails/${email}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function deleteGuestByDocument(eventId, document, token) {
  const config = {
    method: "delete",
    url: `${urlBaseVibra}/events/${eventId}/guests/documents/${document}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}

export async function getAttendeesReport(token) {
  const config = {
    method: "get",
    url: `${urlBaseVibra}/reports/attendees`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosInstance(config).then((res) => res.data);
}
